import {
  COZY_HUB_GAMES,
  cozyHubGameById,
} from '../data/cozyHubGames';

/** @returns {'windDown'|'morning'|'afternoon'|'evening'} */
export function hubTimeOfDay(now = new Date()) {
  const hour = now.getHours();
  if (hour >= 20 || hour < 6) return 'windDown';
  if (hour < 12) return 'morning';
  if (hour < 18) return 'afternoon';
  return 'evening';
}

/**
 * @param {Record<string, boolean>} completion
 * @returns {string|null}
 */
export function hubRecommendNextGameId(completion) {
  for (const game of COZY_HUB_GAMES) {
    if (!completion[game.id]) return game.id;
  }
  return null;
}

/**
 * @param {Record<string, boolean>} completion
 */
export function hubCompletedCount(completion) {
  return COZY_HUB_GAMES.filter((g) => completion[g.id]).length;
}

function capitalizeFirst(s) {
  if (!s) return s;
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/**
 * @param {object} options
 * @param {Date} [options.now]
 * @param {Record<string, boolean>} options.completion
 * @param {string|null|undefined} [options.displayName]
 */
export function buildHubGreeting({ now = new Date(), completion, displayName }) {
  const time = hubTimeOfDay(now);
  const recommendId = hubRecommendNextGameId(completion);
  const recommendTitle = recommendId
    ? cozyHubGameById(recommendId)?.name
    : null;
  const done = hubCompletedCount(completion);
  const total = COZY_HUB_GAMES.length;

  if (!recommendId) {
    return {
      headline: "You're all caught up",
      subline:
        done === total
          ? 'All five dailies done for today. See you tomorrow.'
          : 'Take your time — practice modes are always open.',
      recommendGameId: null,
    };
  }

  const trimmed = displayName?.trim();
  const nameBit = trimmed ? `${trimmed}, ` : '';

  let headline;
  if (time === 'windDown' && recommendId === 'wordMaster') {
    headline = `${nameBit}wind down with today's Word Master`;
  } else if (time === 'windDown') {
    headline = `${nameBit}ease into tonight with ${recommendTitle}`;
  } else if (time === 'morning') {
    headline = `${nameBit}good morning — start with ${recommendTitle}`;
  } else if (time === 'afternoon') {
    headline = `${nameBit}take a calm break with ${recommendTitle}`;
  } else {
    headline = `${nameBit}unwind with ${recommendTitle}`;
  }

  return {
    headline: capitalizeFirst(headline),
    subline: `${done} of ${total} dailies done today`,
    recommendGameId: recommendId,
  };
}
